<template lang="pug">
  b-modal.my-modal(size="xl" id="modal-form" hide-footer)
    template(v-slot:modal-header)
      .my-header
        .title Request Demo
        a.close-button(@click="close()") ✕
    form(@submit="onSubmit" flex  class="mktbi-form")
      .form-row
        .form-group.col-md-6(id="input-group-1" label-for="input-1" class="form-normal")
          input(
            id="input-1"
            placeholder="First Name"
            v-model="form.first_name"
            required
            class="input-form"
          )
        .form-group.col-md-6(id="input-group-3" label-for="input-3" class="form-normal")
          input(
            id="input-3"
            placeholder="Position At Your Company"
            v-model="form.role"
            required
            class="input-form"
          )
      .form-row
        .form-group.col-md-6(id="input-group-2" label-for="input-2" class="form-normal")
          input(
            id="input-2"
            placeholder="Last Name"
            v-model="form.last_name"
            required
            class="input-form"
          )
        .form-group.col-md-6(id="input-group-4" label-for="input-4" class="form-normal")
          input(
            id="input-4"
            placeholder="Email"
            v-model="form.email"
            required
            class="input-form"
          )

      .form-row
        .form-group.col-md-6(id="input-group-5" label-for="input-5" class="form-normal")
          input(
            id="input-4"
            placeholder="Company Name"
            v-model="form.company"
            required
            class="input-form"
          )
        .form-group.col-md-6(id="input-group-6" label-for="input-6" class="form-normal")
          input(
            id="input-4"
            placeholder="Telephone number"
            v-model="form.telephone"
            required
            class="input-form"
          )

      .form-row
        .form-group.col-md-12(id="input-group-6" label-for="input-6" class="form-normal")
          input.comments(
            id="input-4"
            placeholder="Comments"
            v-model="form.message"
            required
            class="input-form"
          )
        button.demo-button.aqua(type="submit") Submit

</template>

<script>
import MailerService from '@/services/MailerService'
  export default {
    name: 'Modal',
    data() {
      return {
        form: {
          first_name: '',
          last_name: '',
          role: '',
          email: '',
          company: '',
          telephone: '',
          message: ''
        },
        mailSent: false,
        mailError: false,
        mandatoryFields: []
        // ,
        // show: true
      }
    },
    props:{
      fontSizes: {
        type: Array,
        default: () => ([ 50, 24, 16 ])
      }
    },
    methods: {
      close () {
        this.form = {
          first_name: '',
          last_name: '',
          role: '',
          email: '',
          company: '',
          telephone: '',
          message: ''
        }
        this.$bvModal.hide("modal-form")
      },
      onSubmit (evt) {
        evt.preventDefault()
        alert(JSON.stringify(this.form)) // Needs to start mail
        this.$bvModal.hide("modal-form")
      }
    }
  }
</script>

<style lang="scss">

  label {
    margin-top: 37px;
    font-size: 20px;
    color: #9497A8;
    &.filled {
      font-weight: bold;
      color: #364149;
    }
  }

  ::placeholder {
    margin-top: 37px;
    font-size: 20px;
    color: #9497A8;
    font-weight: normal;
  }
  .modal-header {
    border-bottom: none !important;
    .my-header {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: space-between;
      align-items: flex-start;
      .title {
        font-style: normal;
        font-weight: bold;
        font-size: 40px;
        line-height: 45px;
        color: #364149;
        margin: 1em 1.5em;
      }
      .close-button {
        font-size: 30px;
        margin: 0.5em;
        color: #9497A8;
        cursor: pointer;
      }
    }
  }
  .modal-body {
    margin: 25px 50px;
  }
  .form-group {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
  .input-form{
    width: 100%;
    height: 55px;
    border: none;
    border-radius: 0%;
    margin-top: 30px;
    border-bottom: 3px solid rgba(148, 151, 168, 0.2) !important;
    outline: none !important;
    padding-bottom: 30px;
    font-size: 20px;
    line-height: 45px;
    font-weight: bold;
    color: #364149;
    &.comments {
      height: 90px;
      padding-bottom: 60px;
    }
  }
  @media (min-width: 576px){
    .modal-dialog {
      max-width: 800px !important;  
    }
  }
</style>